module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/frat-elements-8f7b78b384e2f35084660d2ba7b031c2.png";